/**
 * Returns unique items from an array.
 * @param list - The array of items.
 * @param keyExtractor - Optional function to extract a unique key for objects.
 * @returns An array with unique items.
 */
export const uniqueItems = <T, K = T>(
  list: T[],
  keyExtractor?: (item: T) => K
): T[] => {
  if (!keyExtractor) {
    return Array.from(new Set(list));
  }

  const seen = new Set<K>();
  return list.filter((item) => {
    const key = keyExtractor(item);
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};
